import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import { Component } from 'react';
import AccessibleTooltip from '../AccessibleTooltip';
import Errored from '../Errored';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import withGS from '../withGShoc';
import TrustedDomainDialog from './TrustedDomainDialog';

class SettingsEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      prefixes: [],
      isLoading: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  onAddDomain = (domain) => this.props.onAdd("trustedDomain", domain);

  onRemoveDomain = (domain) => this.props.onDelete("trustedDomain", domain);

  clearError = () => this.setState({ isErrored: false });

  render() {

    const { classes, data } = this.props;
    const { isErrored } = this.state;
    const { trustedDomain } = data;

    if (isErrored) return <Errored dataTest="api-error" data={isErrored} clearError={this.clearError} />;

    return (
      <Grid container spacing={0} style={{ marginBottom: '30px' }}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ width: '100%' }}>
                <TitledPanel
                  dataTest="domains"
                  title="Trusted Domains"
                  actions={<TrustedDomainDialog domains={trustedDomain} onAddDomain={this.onAddDomain} />}>
                  <div style={{ padding: 6, backgroundColor: 'white' }}>
                    {trustedDomain && trustedDomain.length > 0 ?
                      <Table style={{ maxWidth: '100%' }}>
                        <TableHead>
                          <TableRow data-test="headers">
                            <TableCell component="th" className={classes.tableHeading}>Domain</TableCell>
                            <TableCell component="th" style={{textAlign: 'right'}} className={classes.tableHeading}>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody data-test="domain-list">
                          {
                            [...trustedDomain].sort().map((domain, index) => {
                              return <TableRow key={index} data-test={"row-" + index} classes={{
                                root: classes.stripedRow
                              }}>
                                <TableCell className={classes.tableCell}>
                                  <div style={{ paddingTop: 4 }}>
                                    <Typography data-test={domain} variant="body2" className={classes.tableCellText}>{domain}</Typography>
                                  </div>
                                </TableCell>
                                <TableCell className={classes.tableCell} align="right" style={{ maxWidth: 40 }}>
                                  <AccessibleTooltip title="Delete domain">
                                    <IconButton aria-label="Delete domain" data-test="delete-domain" size="small" onClick={() => this.onRemoveDomain(domain)}>
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </AccessibleTooltip>
                                </TableCell>
                              </TableRow>;
                            })
                          }
                        </TableBody>
                      </Table>
                      :
                      <Typography data-test="add-domains" variant="body2">Add domains that you trust for use with OWL imports.</Typography>
                    }
                  </div>
                </TitledPanel>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

SettingsEditor.defaultProps = {
  isReadOnly: true
};

SettingsEditor.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withGS(SettingsEditor));